export default "__VITE_ASSET__8c05fdd4__"